import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-black/80 backdrop-blur-sm border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        
        {/* LOGO QUE REGRESA AL INICIO */}
        <Link to="/" className="flex items-center gap-2 group transition-all">
          <div className="h-10 w-10 rounded-full border-2 border-yellow-400 overflow-hidden bg-white flex items-center justify-center p-0.5 shadow-lg group-hover:scale-110 transition-transform">
            <img 
              src="/logo-pabs.png" 
              alt="PABS Icon" 
              className="h-full w-full rounded-full object-contain"
            />
          </div>
          
          <span className="text-white text-2xl font-black tracking-tighter">
            PABS
          </span>
        </Link>

        {/* NAVEGACIÓN ACTUALIZADA */}
        <div className="flex items-center gap-4">
          {/* Este enlace ahora te lleva a la nueva página de detalles */}
          <Link 
            to="/planes" 
            className="text-gray-300 hover:text-yellow-400 transition-colors text-sm font-bold uppercase tracking-wider"
          >
            Ver Planes
          </Link>

          {/* El botón de Afiliación sigue bajando al formulario en la Home */}
          {/* Nota: Para que este enlace funcione desde la página de planes, 
              puedes usar Link to="/#registro" */}
          <a 
            href="#registro" 
            className="bg-yellow-400 hover:bg-yellow-500 text-black px-5 py-2.5 rounded-full text-sm font-extrabold transition-all transform hover:scale-105 shadow-lg shadow-yellow-400/10"
          >
            Afiliarme
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;